import { createAction, props, union } from '@ngrx/store';

import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';
import { StatsActionI } from 'src/app/api/stats-action/stats-action.result.int';
import { StatsActionQueryI } from 'src/app/api/stats-action/stats-action.query.int';

export const error = createAction('[Stats / Action] Error', props<{ error: SharedErrorObjectI }>());
export const load = createAction('[Stats / Action] Load', props<{
    query: StatsActionQueryI;
}>());
export const received = createAction('[Stats / Action] Received', props<{
    result: StatsActionI;
}>());
export const reset = createAction('[Stats / Action] Reset', props<Record<string, unknown>>());

const all = union({
    error,
    load,
    received,
    reset,
});
export type Actions = typeof all;
